import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './VerifyEmail.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [verifying, setVerifying] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (!token) {
      setError('Ugyldig verifiseringslenke');
      setVerifying(false);
      return;
    }

    verifyEmail(token);
  }, [searchParams]);

  const verifyEmail = async (token: string) => {
    try {
      await axios.get(`${API_URL}/profile/verify-email?token=${token}`);
      setSuccess(true);
      
      // Redirect to login after 3 seconds
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Verifisering feilet. Lenken kan være ugyldig eller utløpt.');
    } finally {
      setVerifying(false);
    }
  };

  if (verifying) {
    return (
      <div className="verify-email-container">
        <div className="verify-card">
          <div className="spinner"></div>
          <h1>Verifiserer e-postadresse...</h1>
          <p>Vennligst vent et øyeblikk.</p>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="verify-email-container">
        <div className="verify-card success">
          <div className="success-icon">✓</div>
          <h1>E-postadresse verifisert!</h1>
          <p>Din e-postadresse er nå bekreftet.</p>
          <p className="redirect-message">Du blir sendt til pålogging om et øyeblikk...</p>
          <button onClick={() => navigate('/login')} className="btn-primary">
            Gå til pålogging
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="verify-email-container">
      <div className="verify-card error">
        <div className="error-icon">✗</div>
        <h1>Verifisering feilet</h1>
        <p>{error}</p>
        <div className="error-actions">
          <button onClick={() => navigate('/login')} className="btn-secondary">
            Gå til pålogging
          </button>
          <button onClick={() => navigate('/registrer')} className="btn-primary">
            Registrer deg på nytt
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
